<template>
  <button
    :disabled="disabled"
    :class="boxStyle"
    @click="boxSelect">

    <span>
      <q-icon
        width="20px"
        name="checkBoxOff"
        altName="checkBoxOn"
        :active="isActive"
        :allowSelfUpdate="false" />

      <span
        :style="{'font-size': customFontSize}"
        :class="{'box-text': true, 'bold': boldLabels, 'spaced-labels': spacedLabels}">
        {{ label }}

      </span>
    </span>
  </button>
</template>

<script>
import QIcon from '@/components/standard/display/QIcon'

export default {
  methods: {
    boxSelect (e) {
      this.$emit('select', {
        name: this.name,
        value: this.isActive,
        sideValue: this.value
      })
    }
  },
  computed: {
    isActive () {
      return !!this.active[this.name]
    },
    boxStyle () {
      let base = 'box-btn'
      if (this.isActive) base = `${base} active-box-btn`
      if (this.disabled) base = `${base} disabled-box-btn`
      
      return base
    }
  },
  props: {
    spacedLabels: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    customFontSize: {
      type: String,
      required: false,
    },
    boldLabels: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    }
  },

  components: {
    'q-icon': QIcon
  }
}
</script>

<style scoped>
.box-btn {
  border: none;
  outline: border;
  cursor: pointer;
  background-color: transparent;
  opacity: 1;
  transition: all .3s;
}
.box-text {
  font-weight: lighter;
  line-height: 17px;
  color: #353635;
}

.bold {
  font-weight: bold;
}

.spaced-labels {
  margin-left: 7px;
}

.disabled-box-btn {
  opacity: 0.5;
  cursor: not-allowed;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/form/customItems/CheckBox.vue?35bbcf40